import dayjs from "dayjs";

type TimeSlotLike = {
  date?: string | null;
  hour_from?: string | null;
  hour_to?: string | null;
  start?: string | null;
  stop?: string | null;
};

const formatTimeSlotTime = (
  date: string | null | undefined,
  time: string | null | undefined,
  format: string,
) => {
  if (!date || !time) {
    return "";
  }

  const parsedDateTime = dayjs(`${date}T${time}`);

  if (!parsedDateTime.isValid()) {
    return "";
  }

  return parsedDateTime.format(format);
};

export const formatTimeSlotRange = (
  timeSlot: TimeSlotLike | null | undefined,
  format: string,
) => {
  const from = formatTimeSlotTime(
    timeSlot?.date,
    timeSlot?.hour_from ?? timeSlot?.start,
    format,
  );
  const to = formatTimeSlotTime(
    timeSlot?.date,
    timeSlot?.hour_to ?? timeSlot?.stop,
    format,
  );

  if (!from || !to) {
    return "";
  }

  return `${from} - ${to}`;
};
